<template>
  <div class="sf-bg-white sf-layer-rounded sf-border-box sf-below-2">
    <div class="sf-inbox" style="height: calc(100vh - 208px)">
      <div class="sf-inbox-messages">
        <div
          :class="{ active: isActive(OVERVIEW) }"
          class="
            sf-layer-rounded
            sf-pad-h-3
            sf-pad-v-2
            sf-below-2
            sf-inbox-messages-nav
          "
          @click="handleOverviewClick"
        >
          <div class="sf-inbox-messages-nav-title sf-font-m sf-fwdb">
            {{ I18n.t('inbox.pulse.overview.title') }}
          </div>
          {{ I18n.t('inbox.pulse.overview.secondary_text') }}
        </div>
        <div class="sf-inbox-messages-content" :class="hideSessionClass">
          <div
            :class="{ active: isActive(MYINBOX) }"
            class="sf-pad-h-3 sf-pad-v-2 sf-inbox-messages-nav"
            @click="handleMyInboxClick"
          >
            <div class="sf-inbox-messages-nav-title sf-font-m sf-fwdb">
              {{ I18n.t('inbox.pulse.my_inbox') }}
            </div>
          </div>
          <div v-if="loadingNotifications">
            <div class="sf-level sf-level-around sf-pad-2">
              <div class="sf-spinner sf-spinner-l"></div>
            </div>
          </div>
          <div v-else :class="hideSessionClass">
            <notification-preview
              v-for="preview in notifications"
              :key="preview.id"
              :is-active="preview.id === activeNotificationId"
              v-bind="preview"
              @click="handleClick"
              @markUnread="handleMarkUnread"
            ></notification-preview>
          </div>
        </div>
      </div>
      <div class="sf-inbox-detail sf-inbox-detail-pulse">
        <template v-if="isActive(MYINBOX)"
          ><template v-if="!loadingNotifications && notifications.length === 0"
            ><empty-state :text="I18n.t('inbox.empty_state.no_messages_title')"
              ><div class="sf-pad-v-2">
                <new-remark-button
                  :ledger-id="context.ledgerId"
                  :ledger-label="context.ledgerLabel"
                  :owner-id="context.ownerId"
                  owner-type="Company"
                ></new-remark-button></div></empty-state></template
          ><template v-else
            ><notification-content
              :communication-item="communicationItem"
              :show-tags="false"
            ></notification-content></template
        ></template>
        <div v-show="isActive(OVERVIEW)" class="sf-pad-2">
          <div v-dompurify-html="renderedHTML"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { hasQueryParam } from '@app/utils/url-helpers'

import NotificationContent from './notification-content.vue'
import NotificationPreview from './notification-preview.vue'
import EmptyState from './empty-state.vue'
import NewRemarkButton from '@app/shared/vue/components/new-remark/new-remark-button'
import useRedactSessionRecording from '@app/shared/vue/composables/use-hide-session-recording'

const MYINBOX = 'my-inbox'
const OVERVIEW = 'overview'

export default {
  components: {
    NotificationContent,
    NotificationPreview,
    EmptyState,
    NewRemarkButton,
  },

  props: {
    renderedHTML: {
      type: String,
      default: '',
    },
    context: {
      type: Object,
      default: () => ({}),
    },
  },

  setup() {
    const hideSessionClass = useRedactSessionRecording()
    return {
      hideSessionClass,
      MYINBOX,
      OVERVIEW,
    }
  },

  data() {
    const active = hasQueryParam('activeNotificationId') ? MYINBOX : OVERVIEW
    return {
      active,
    }
  },

  computed: {
    ...mapGetters([
      'activeNotificationId',
      'notifications',
      'communicationItem',
      'loadingNotifications',
    ]),
  },

  created() {
    this.fetchNotifications()
    this.fetchMentionUsernames()

    // It is an event emmited by "edit-remark-modal", we have to refresh content of remark after update
    window.eventHub.$on(
      'refreshCommunicationData',
      this.refreshNotificationData
    )
  },

  beforeUnmount() {
    window.eventHub.$off(
      'refreshCommunicationData',
      this.refreshNotificationData
    )
  },

  methods: {
    ...mapActions([
      'fetchNotifications',
      'refreshNotificationData',
      'handleNotificationClick',
      'handleNotificationUnread',
      'fetchMentionUsernames',
      'resetActiveNotification',
    ]),
    isActive(active) {
      return this.active === active
    },
    handleOverviewClick() {
      this.resetActiveNotification()
      this.active = OVERVIEW
    },
    handleClick(id) {
      this.active = MYINBOX
      this.handleNotificationClick(id)
    },
    handleMyInboxClick() {
      this.active = MYINBOX
      if (this.notifications.length > 0) {
        this.handleNotificationClick(this.notifications[0].id)
      }
    },
    handleMarkUnread(id) {
      this.handleNotificationUnread(id)
    },
  },
}
</script>
